import UnAuthRoute from "./UnAuthRoute";

export default UnAuthRoute;